import React from 'react'
import GroupBatchRow from './GroupBatchRow'

const GroupBatchTable = (props) => {
    const { data, reload } = props

    return (
        <div className='GroupBatchTable'>
            <table className='table table-borderless table-striped'>
                <thead className='thead-light'>
                    <tr>
                        <th className='Name'>Mã nhóm</th>
                        <th className="colDate">Danh sách lô</th>
                        <th className="Product-type">Ngày tạo</th>
                        <th className="Status">Người tạo</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.length > 0 ? (
                            data.map((item, index) => {
                                return (
                                    <GroupBatchRow
                                        item={item}
                                        key={item._id}
                                        reload={reload}
                                    />
                                )
                            }
                            )
                        ) : (
                            <tr>
                                <td colSpan={4}>No data</td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </div>
    )
}

export default GroupBatchTable